window.addEventListener("load", (event) => {
  if ($(".banner_images").length) {
    $(".banner_images").owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      autoplay: true,
      autoplayTimeout: 7000,
      autoplayHoverPause: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 1,
        },
      },
    });
  }
  jQuery(".more_color .more_title").click(function () {
    jQuery(this).toggleClass("active");
    jQuery(this).siblings("div").animate({ height: "toggle" });
  });
  jQuery('.track_order input[type="submit"]').click(function () {
    var url = "https://zoom-ops.rivigo.com/#/trackconsignment/";
    var url_after = jQuery("#waybl_no_ht").val();
    var confirm_url = url + url_after;
    //window.open(confirm_url, '_blank');
    jQuery(".track_order").append(
      '<iframe src="' + confirm_url + '" height="400" width="100%"></iframe>'
    );
  });

  // $( ".product-view .detail-price" ).append( ".product-view .labels" );

  jQuery(".faq-section .accordion-toggle").click(function (event) {
    event.preventDefault();
    if (jQuery(this).next(".content").is(":visible")) {
      jQuery(this).next(".content").slideUp("100");
      jQuery(this).removeClass("active");
    } else {
      jQuery(this).next(".content").slideDown("100");
      jQuery(this).addClass("active");
    }
  });

  jQuery(document).ready(function (e) {
    if (jQuery(".block_content.all_collections_new .rows").length) {
      jQuery(".block_content.all_collections_new .rows").owlCarousel({
        loop: false,
        dots: false,
        nav: true,
        margin: 0,
        autoplay: false,
        autoplayTimeout: 2000,
        responsive: {
          0: {
            items: 3,
          },
          767: {
            items: 4,
          },
          1000: {
            items: 5,
          },
          1190: {
            items: 6,
          },
        },
      });
    }
  });
});

jQuery(document).ready(function ($) {
  jQuery(".video_button_row").click(function () {
    jQuery(".size_chart_modal").addClass("is-visible");
    if($('.box_product_page .product-view .product-img-box').length){
      $('.box_product_page .product-view .product-img-box').css('z-index',999999);
    }
    // jQuery(".quick-view-modal").hide();
  });
  jQuery(".close").click(function () {
    jQuery(".size_chart_modal").removeClass("is-visible");
    if($('.box_product_page .product-view .product-img-box').length){
      $('.box_product_page .product-view .product-img-box').css('z-index','auto');
    }
  });
});
